import React from 'react'
import { Label } from 'semantic-ui-react'

const LabelTag = (props) => (
  <div className="label-tag">
    <Label as='a' tag>{props.labeltag.ui_design}</Label>
    <Label as='a' color='red' tag>{props.labeltag.front_end}</Label>
    <Label as='a' color='teal' tag>{props.labeltag.back_end}</Label>
  </div>
)

export default LabelTag



// WEBPACK FOOTER //
// ./src/components/LabelTag.js